module.exports = __webpack_public_path__ + "static/media/filter-cert.3e99a567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/filter-cert.jpg
// module id = 1926
// module chunks = 0